
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Urbaniahireforcorporate() {



 const cardData =
{
  keyword: 'Urbania Hire for Corporate Event in Pune',
  heading: 'eTravo: Urbania Hire for Corporate Event in Pune',
  headingDescription: 'Looking for group travel solutions for your next corporate event in Pune? eTravo offers premium Urbania vans on hire that are perfect for transporting employees, executives, and event staff in comfort and style. Whether it’s a conference, business meeting, team outing, or airport transfer for large groups, our fleet of AC Urbania vans is spacious, reliable, and equipped with safety features. With professional drivers, GPS tracking, and flexible booking options, eTravo ensures seamless, punctual, and hassle-free transport for all your corporate travel needs across Pune.',

  top: 'Top Places to Visit in Pune for Corporate Events & Offsites',
  topPlaces: [
    {
      title: 'Aamby Valley City',
      description: 'Located around 90 km from Pune, Aamby Valley is a luxurious and serene destination ideal for high-end corporate retreats, leadership workshops, and team bonding activities. Our Urbania vans provide a smooth ride through hilly terrain, offering enough space for employees and event essentials, ensuring you arrive fresh and relaxed.'
    },
    {
      title: 'Oxford Golf Resort',
      description: 'A premium venue near Lavale, popular for golf-based corporate team outings and strategy meets. eTravo’s Urbania vans are frequently booked for transporting mid-sized teams, golf kits, and event materials comfortably to and from this scenic location.'
    },
    {
      title: 'Hilton Hotel Pune',
      description: 'Located in Koregaon Park, the Hilton is a favorite venue for corporate dinners, workshops, and seminars. Our Urbania vans are the preferred mode of transport for companies hosting multi-department events here, allowing smooth group coordination and travel.'
    },
    {
      title: 'Mantra Resort Pune',
      description: 'A popular offsite location known for corporate picnics and wellness events. Urbania vans offer spacious seating, luggage room, and AC interiors – ideal for a comfortable journey to this hilly countryside destination just outside Pune.'
    },
    {
      title: 'Pune International Exhibition and Convention Centre (PIECC)',
      description: 'A large venue in Moshi hosting trade fairs, conferences, and expos. Our Urbania vans are ideal for shuttling staff, visitors, and booth materials to this high-traffic event zone, ensuring punctual and coordinated entry.'
    },
    {
      title: 'JW Marriott Hotel Pune',
      description: 'One of the most luxurious 5-star venues in Pune used for product launches and client meetings. eTravo’s Urbania vans deliver smooth corporate group transfers directly to the venue entrance, maintaining both comfort and brand image.'
    },
    {
      title: 'The Corinthians Resort & Club',
      description: 'Ideal for weekend conferences and business celebrations. Located in Undri, it provides a relaxing break for your team. Urbania vans help manage bulk movement of staff with ease, with ample legroom and luggage space.'
    },
    {
      title: 'Baner Business Bay',
      description: 'A tech-commercial hub where corporate training programs and onboarding events are held regularly. Urbania shuttles ensure stress-free transportation for staff from various corners of Pune to this central location.'
    },
    {
      title: 'Della Adventure Park Lonavala',
      description: 'A thrilling location for team-building exercises and HR offsites. eTravo’s Urbania vans are equipped for long-distance rides, offering your team a secure and comfortable way to start the adventure.'
    },
    {
      title: 'Raga Lawns Pune',
      description: 'Often selected for formal networking dinners, this venue in Koregaon Park demands punctual, group-oriented travel. Our Urbania vans handle multi-trip shuttles for event guests efficiently and with professionalism.'
    }
  ],

  services: [
    {
      name: 'AC Urbania Rental for Corporate Events Pune',
      description: 'eTravo offers fully air-conditioned Urbania vans ideal for mid-sized corporate groups attending events across Pune. Whether it’s a formal seminar or a relaxed offsite, our vehicles deliver comfort, cool interiors, and a pleasant travel experience for your entire team.'
    },
    {
      name: 'Business Event Transport Urbania Pune',
      description: 'Planning a business event in Pune? Our Urbania rental service ensures hassle-free, timely, and group-friendly transport for event participants, speakers, and staff—perfect for locations with limited parking or multiple sessions.'
    },
    {
      name: 'Corporate Staff Shuttle Urbania Pune',
      description: 'Daily or one-time shuttle services for corporate staff across industrial areas or office parks in Pune. Our Urbania vans offer safe, GPS-tracked, and professionally managed rides for morning and evening shifts.'
    },
    {
      name: 'Urbania Vans for Corporate Travel Pune',
      description: 'Traveling as a team to a business meeting, branch office, or leadership retreat? Our Urbania vans offer spacious interiors, seatbelts, rear AC, and professional chauffeurs for safe, stress-free corporate journeys.'
    },
    {
      name: 'Urbania for Conference Transport Pune',
      description: 'Ensure punctual arrival for all participants at citywide conferences and expos. eTravo’s Urbania fleet helps with group coordination, multiple pickups, and return drop-offs with a single booking window.'
    },
    {
      name: 'Urbania for Business Meetings Pune',
      description: 'Looking to pick up multiple team members for a city-wide business pitch? Our Urbania vans offer enough legroom, laptop-friendly seating, and quiet rides to help your team prep before the meeting.'
    },
    {
      name: 'Affordable Urbania on Rent Pune',
      description: 'eTravo offers budget-friendly Urbania hire without compromising on vehicle condition or driver quality. We help you save costs on group travel logistics while maintaining corporate travel standards.'
    },
    {
      name: 'Urbania for Team Outings Pune',
      description: 'Planning a corporate picnic or adventure outing? Our Urbania vans are perfect for offsites, with durable suspension, clean seating, and enough room to carry equipment, snacks, and luggage.'
    },
    {
      name: 'Corporate Tour Urbania Rental Pune',
      description: 'For company-organized city tours or factory visits, our Urbania rental ensures your itinerary runs smoothly. Our team helps with route planning, scheduling, and standby support throughout your tour.'
    },
    {
      name: 'Reliable Urbania Rentals Pune',
      description: 'Our Urbania rental service is trusted by over 200+ corporate clients in Pune. With on-time service, backup vehicles, and trained drivers, we’re ready for last-minute plans and large group logistics.'
    }
  ],

  tableData: [
    ['AC Urbania Rental for Corporate Events Pune', 'Business Event Transport Urbania Pune'],
    ['Corporate Staff Shuttle Urbania Pune', 'Urbania Vans for Corporate Travel Pune'],
    ['Urbania for Conference Transport Pune', 'Urbania for Business Meetings Pune'],
    ['Affordable Urbania on Rent Pune', 'Urbania for Team Outings Pune'],
    ['Corporate Tour Urbania Rental Pune', 'Reliable Urbania Rentals Pune']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Spacious and Premium Urbania for Corporate Events",
        "WhyChoosedescription": "eTravo offers Tata Urbania vans equipped with plush interiors, advanced suspension, and ample legroom—ideal for transporting teams, speakers, and VIP guests during business events in Pune."
    },
    {
        "WhyChooseheading": "Ideal for Group Transfers and Team Logistics",
        "WhyChoosedescription": "Urbania is the perfect choice for mid-sized groups attending conferences, team outings, or client meets. With seating capacity for up to 20 passengers, it provides a comfortable and coordinated travel experience."
    },
    {
        "WhyChooseheading": "Tailored Packages for Full-Day or Event-Based Hire",
        "WhyChoosedescription": "Whether it’s a full-day event or just a few hours of travel, our Urbania rental packages are designed with flexible time slots and competitive rates to suit corporate agendas."
    },
    {
        "WhyChooseheading": "Trained Chauffeurs for Smooth and Professional Service",
        "WhyChoosedescription": "Our experienced drivers ensure a smooth ride and timely arrivals for all your corporate attendees. They are well-versed with Pune routes and maintain professional etiquette throughout the service."
    },
    {
        "WhyChooseheading": "Event Coordination and Transport Scheduling Support",
        "WhyChoosedescription": "For multi-location pick-ups, airport transfers, and synchronized drops, eTravo provides a dedicated event manager who ensures all transport operations run on schedule."
    },
    {
        "WhyChooseheading": "Clean, Sanitized Vehicles with Corporate-Level Amenities",
        "WhyChoosedescription": "All Urbania vans are sanitized before each trip and come with AC, pushback seats, USB ports, and bottle holders—providing a premium experience your employees and guests will appreciate."
    },
    {
        "WhyChooseheading": "GPS Tracking and Real-Time Monitoring",
        "WhyChoosedescription": "All vehicles are GPS-enabled, allowing you to monitor movement live and receive ETA updates to ensure better planning and coordination during the event."
    },
    {
        "WhyChooseheading": "Corporate Billing with GST and Transparent Invoicing",
        "WhyChoosedescription": "Our billing system supports GST-compliant invoices, itemized trip details, and monthly billing options—perfect for finance and procurement teams managing multiple events."
    }
]
}


const faqData = [
    [
        {
            question: 'What is the seating capacity of the Urbania vehicle for corporate rentals?',
            answer: 'Urbania vehicles typically seat 17 to 20 passengers, making them ideal for mid-sized corporate teams attending business events, site visits, or conferences.'
        },
        {
            question: 'Can we book Urbania for just a few hours?',
            answer: 'Yes, you can hire Urbania for hourly use, half-day, or full-day schedules depending on the nature and timing of your corporate event.'
        },
        {
            question: 'Does eTravo provide real-time tracking and route management?',
            answer: 'Yes, all Urbania vehicles are GPS-enabled with live tracking support so that you can monitor routes and receive accurate ETAs.'
        },
        {
            question: 'Are drivers experienced in handling corporate event logistics?',
            answer: 'Absolutely. Our chauffeurs are professionally trained, punctual, and experienced in managing corporate travel with high service standards.'
        },
        {
            question: 'Can Urbania be used for airport transfers during a business event?',
            answer: 'Yes, Urbania is an excellent option for group airport transfers before and after your event, ensuring timely pickups and convenient drop-offs.'
        },
        {
            question: 'Is billing GST compliant and suitable for corporate accounting?',
            answer: 'Yes, we provide full GST-compliant invoices with clear itemization, suitable for audit and internal expense reporting.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Aditya Thombre',
        designation: 'Operations Head, EliteX Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired Urbania vans from eTravo for our tech expo. Spacious seating, clean interiors, and seamless coordination made everything easy for our teams and guests.”'
    },
    {
        name: 'Ms. Rupal Khedekar',
        designation: 'Event Planner, Auron Events Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“The Urbania service by eTravo was perfect for our corporate seminar in Pune. Drivers were on time, and the entire ride was smooth and comfortable.”'
    }
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Event in Pune",
  "image": "https://www.etravo.in/images/keyword/urbania-hire-corporate-event-pune.jpg",
  "description": "Book Urbania vans for corporate events in Pune with eTravo. Ideal for staff shuttles, executive transport, team outings, and business meetings. Choose AC luxury or affordable Urbania rental options with professional drivers and on-time service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6792"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/urbania-hire-corporate-event-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Urbania Hire for Corporate Event in Pune | Staff Shuttle & Executive Vans | eTravo</title>
  <meta 
    name="description" 
    content="Hire AC Urbania vans for corporate events, staff transport, business trips, and team outings in Pune. Affordable, comfortable, and reliable Urbania rental from eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireforcorporate;